import React, { Component } from "react";
import PropTypes from "prop-types";
import { payNoPainDigest, getPayNoPainTransactions } from "../../../utils/witbookingApi";
import constants from "../../../utils/constants";
import styles from "./PayNoPainBridge.scss";
import PayNoPainErrorMessage from "./PayNoPainErrorMessage/PayNoPainErrorMessage";
import { executeEvent } from "../../../utils/misc";
import { ComodoSSLIcon, PCIDSSIcon } from "../../../theme/assets";
import classnames from "classnames";

function createInput(name, value) {
  const elem = document.createElement("input");
  elem.setAttribute("type", "hidden");
  elem.setAttribute("name", name);
  elem.setAttribute("value", value);
  return elem;
}

function createSubmitInput() {
  const elem = document.createElement("input");
  elem.setAttribute("id", "submitTokenizedCCForm");
  elem.setAttribute("type", "submit");
  elem.setAttribute("name", "submitTokenizedCC");
  elem.setAttribute("value", "Submit");
  return elem;
}

function createForm(PNPObject) {
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("target", "PNPIframe");
  form.setAttribute("action", "https://gateway.paynopain.com/ws/gateway");
  form.setAttribute("class", styles.payNoPainForm);

  form.appendChild(createInput("PNPClient", PNPObject.PNPClient));
  form.appendChild(createInput("PNPGateway", PNPObject.PNPGateway));
  form.appendChild(createInput("PNPData", PNPObject.PNPData));
  form.appendChild(createInput("PNPDigest", PNPObject.PNPDigest));
  form.appendChild(createSubmitInput());
  return form;
}

class PayNoPainBridge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failedTransaction: null,
    };
  }

  componentDidMount() {
    window.addEventListener("message", data => {
      const modalContainer = document.getElementsByClassName("wbkv9-Modal-modalContainer")[0];
      const payNoPainHeader = document.getElementsByClassName("wbkv9-Modal-PayNoPainHeader")[0];
      const payNoPainIframe = document.getElementsByClassName("wbkv9-Modal-PayNoPainIframe")[0];
      const payNoPainFooter = document.getElementsByClassName("wbkv9-Modal-PayNoPainFooter")[0];

      switch (data.data) {
        case "redirecting_to_3ds":
          modalContainer.style.width = "600px";
          modalContainer.style.maxWidth = "100%";
          modalContainer.style.height = "700px";
          modalContainer.style.maxHeight = "100%";

          if (window.innerHeight < 700) {
            payNoPainIframe.style.height =
              window.innerHeight -
              (payNoPainHeader.offsetHeight + payNoPainFooter.offsetHeight) +
              "px";
          } else {
            payNoPainIframe.style.height = "523px";
          }
          break;

        case "amex_detected":
          modalContainer.style.width = "404px";
          modalContainer.style.maxWidth = "100%";
          modalContainer.style.height = "590px";
          modalContainer.style.maxHeight = "100%";

          if (window.innerHeight < 590) {
            payNoPainIframe.style.height =
              window.innerHeight -
              (payNoPainHeader.offsetHeight + payNoPainFooter.offsetHeight) +
              "px";
          } else {
            payNoPainIframe.style.height = "413px";
          }
          break;

        default:
          break;
      }
    });

    if (this.props.match && this.props.match.params && this.props.match.params.reservationId) {
      if (this.props.match.params.status) {
        switch (this.props.match.params.status) {
          case constants.PAYMENT_STATUS.SUCCESS:
            window.parent.postMessage(
              {
                propertyTicker: this.props.match.params.hotelTicker,
                reservationId: this.props.match.params.reservationId,
                status: constants.PAYMENT_STATUS.SUCCESS,
              },
              "*"
            );
            break;

          case constants.PAYMENT_STATUS.FAILURE:
            window.parent.postMessage(
              {
                propertyTicker: this.props.match.params.hotelTicker,
                reservationId: this.props.match.params.reservationId,
                status: constants.PAYMENT_STATUS.FAILURE,
              },
              "*"
            );
            break;

          default:
            break;
        }
      }
    }

    const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, event => {
      if (event.data) {
        switch (event.data.status) {
          case constants.PAYMENT_STATUS.SUCCESS:
            this.props.handleSuccess(event.data.reservationId);
            break;

          case constants.PAYMENT_STATUS.FAILURE:
            this.handleFailure(event.data.reservationId);
            break;

          default:
            break;
        }
      }
    });

    if (this.props.propertyTicker && this.props.reservationId) {
      payNoPainDigest(
        {},
        {
          propertyTicker: this.props.propertyTicker,
          idReservation: this.props.reservationId,
          language: this.props.locale,
        }
      ).then(PNPObject => {
        const form = createForm(PNPObject);
        if (form) {
          document.body.appendChild(form);
          form.querySelector("#submitTokenizedCCForm").click();
        }
      });
    }
  }
  getTransactionDetails({ propertyTicker, reservationId }) {
    // show loader
    getPayNoPainTransactions({}, { reservationId, propertyTicker })
      .then(transactions => {
        // hide loader
        if (transactions && transactions.length > 0) {
          this.setState({ transactions: transactions, failedTransaction: transactions[0] });
        }
      })
      .catch(err => {
        // hide loader
        console.log("ERROR");
        console.log(err);
        this.setState({ error: err });
      });
  }
  handleFailure(reservationId) {
    this.getTransactionDetails({ propertyTicker: this.props.propertyTicker, reservationId });
    payNoPainDigest(
      {},
      {
        propertyTicker: this.props.propertyTicker,
        idReservation: this.props.reservationId,
        language: this.props.locale,
      }
    ).then(PNPObject => {
      const form = createForm(PNPObject);
      if (form) {
        window.wbkPaymentModalPhase = constants.PAYMENT_MODAL_PHASES.ERROR;

        executeEvent(constants.EVENTS.PAYMENT_MODAL);

        document.body.appendChild(form);
        form.querySelector("#submitTokenizedCCForm").click();
      }
    });
  }

  render() {
    const { propertyName, propertyContact, params } = this.props;

    if (params && params.status) {
      return false;
    }

    return (
      <div>
        <div className={classnames("wbkv9-Modal-PayNoPainHeader", styles.header)}>
          <div
            className={classnames("wbkv9-Modal-PayNoPainHeader-propertyName", styles.propertyName)}>
            {propertyName}
          </div>
          <div
            className={classnames(
              "wbkv9-Modal-PayNoPainHeader-propertyAddress",
              styles.propertyAddress
            )}>
            {propertyContact && propertyContact.get("city")}
          </div>
        </div>
        {this.state.failedTransaction && (
          <PayNoPainErrorMessage transaction={this.state.failedTransaction} />
        )}
        <iframe
          className={classnames("wbkv9-Modal-PayNoPainIframe", styles.payNoPainIframe)}
          name="PNPIframe"></iframe>
        <div className={classnames("wbkv9-Modal-PayNoPainFooter", styles.footer)}>
          <div
            className={classnames(
              "wbkv9-Modal-PayNoPainFooter-leftIcon",
              "wbkv9-Modal-PayNoPainFooter-Icon"
            )}>
            <ComodoSSLIcon />
          </div>
          <div
            className={classnames(
              "wbkv9-Modal-PayNoPainFooter-rightIcon",
              "wbkv9-Modal-PayNoPainFooter-Icon"
            )}>
            <PCIDSSIcon />
          </div>
        </div>
      </div>
    );
  }
}

PayNoPainBridge.propTypes = {
  failedTransaction: PropTypes.object,
  propertyTicker: PropTypes.string,
  reservationId: PropTypes.string,
  params: PropTypes.object,
  handleSuccess: PropTypes.func,
  handleFailure: PropTypes.func,
  chargeCurrency: PropTypes.string,
  propertyName: PropTypes.string,
  propertyContact: PropTypes.object,
  locale: PropTypes.string,
};

export default PayNoPainBridge;
